import { Loader } from '@googlemaps/js-api-loader';
import pinURL from 'url:../../svg/map-pin.svg';
import { googleMapsStyle } from '../lib/googleMapsStyle';

async function initMap() {
  const mapElement = document.querySelector('.contacts__map');
  if (!mapElement) return;

  const shopLocation = { lat: 51.29284, lng: 6.8307 };

  const zoomIn = document.querySelector('.contacts__zoomin');
  const zoomOut = document.querySelector('.contacts__zoomout');
  const getLocation = document.querySelector('.contacts__get-location');

  const loader = new Loader({
    apiKey: process.env.GOOGLE_MAPS_KEY,
    version: 'weekly',
  });

  const { Map } = await loader.importLibrary('maps');
  const { Marker } = await loader.importLibrary('marker');

  const map = new Map(mapElement, {
    center: { lat: 51.2928033, lng: 6.830668 },
    zoom: 14,
    disableDefaultUI: true,
    scrollwheel: false,
    backgroundColor: '#282828',
    styles: googleMapsStyle,
  });

  new Marker({
    position: shopLocation,
    map,
    icon: pinURL,
  });

  zoomIn.addEventListener('click', () => {
    map.setZoom(map.zoom + 1);
  });
  zoomOut.addEventListener('click', () => {
    map.setZoom(map.zoom - 1);
  });
  getLocation.addEventListener('click', () => {
    map.setCenter(shopLocation);
  });
}

export function contacts() {
  initMap().then();
}
